const usuarios = {
  login(params) {
    return fetch(
      `${process.env.REACT_APP_API_USUARIOS}api/usuarios/login`,
      params
    )
  },
  loginFacebook(response) {
    return fetch(
      `${process.env.REACT_APP_API_USUARIOS}api/usuarios/loginSocialFacebook?accessToken=${response.accessToken}`,
      {
        method: 'post',
        headers: { 'Content-Type': 'application/json' }
      }
    )
  },
  getMenuHorizontal() {
    return fetch(
      `${process.env.REACT_APP_API_ENDPOINT}` +
        'busca-produtos/api/categoriasMenuHorizontal'
    )
  },
  getEsqueciSenha(token, cid) {
    return fetch(
      `${process.env.REACT_APP_API_USUARIOS}api/esqueci-minha-senha/dados-esqueci-senha?token=${token}&cid=${cid}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }
    )
  },
  trocarSenha(params) {
    return fetch(
      `${process.env.REACT_APP_API_USUARIOS}api/esqueci-minha-senha/trocar-senha`,
      params
    )
  },
  alterarSenha(params) {
    return fetch(`${process.env.REACT_APP_API_CLIENTES}clientes/senha`, params)
  },
  alterarEmail(params) {
    return fetch(`${process.env.REACT_APP_API_CLIENTES}clientes/email`, params)
  },
  // alterarEmailV2(params) {
  //   return fetch(
  //     `${process.env.REACT_APP_API_CHECKOUT}api/Pedido/AlterarEmail`,
  //     params
  //   )
  // }
  async alterarEmailV2(body, token) {
    return await fetch(
      `${process.env.REACT_APP_API_CHECKOUT}api/Pedido/AlterarEmail`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(body)
      }
    )
  }
}

export default usuarios
